function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelmholtzIcon = function SvgHelmholtzIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 175.775,
    height: 175.775,
    viewBox: "0 0 46.507 46.507"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M63.628 78.12a23.254 23.254 0 0 0-23.253 23.253 23.254 23.254 0 0 0 23.253 23.254 23.254 23.254 0 0 0 23.254-23.254A23.254 23.254 0 0 0 63.628 78.12m-9.61 10.024h5.076v10.708h9.067V88.144h5.077v26.458H68.16v-10.67h-9.067v10.67h-5.075z",
    style: {
      fill: "#002864",
      stroke: "none",
      strokeWidth: 0.174,
      strokeLinejoin: "bevel",
      stopColor: "#000"
    },
    transform: "translate(-40.375 -78.12)"
  }));
};
export default SvgHelmholtzIcon;